export class ScrollService {
  static scrollToTop(): void {
    window.scrollTo(0, 0);
  }
}
